import { fill } from '../../ass_components/chatbot/faq';

/** Sujets proposés dans le formulaire ; les libellés sont dans i18n (`contact.topics.<id>`). */
export const TOPICS = ['account', 'subscription', 'marketplace', 'jobs', 'technical', 'partnership', 'other'];

export const MESSAGE_MIN = 20;
export const MESSAGE_MAX = 2000;

export const EMPTY_MESSAGE = { name: '', email: '', phone: '', topic: '', message: '', consent: false, website: '' };

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE = /^\+?[0-9][0-9\s().-]{5,19}$/;

/** Erreurs de saisie, par champ (clé = nom du champ, valeur = clé du texte i18n `contact.errors`). */
export const validate = (values) => {
    const errors = {};
    if (values.name.trim().length < 2) errors.name = 'name';
    if (!EMAIL.test(values.email.trim())) errors.email = 'email';
    if (values.phone.trim() && !PHONE.test(values.phone.trim())) errors.phone = 'phone';
    if (!TOPICS.includes(values.topic)) errors.topic = 'topic';
    if (values.message.trim().length < MESSAGE_MIN) errors.message = 'message';
    if (!values.consent) errors.consent = 'consent';
    return errors;
};

/** Objet de l'email : « [Contact] Abonnement et facturation ». */
export const subjectOf = (values, texts) =>
    fill(texts.mail.subject, { topic: texts.topics[values.topic] || texts.topics.other });

/** Corps de l'email : le message, puis les coordonnées renseignées. */
export const bodyOf = (values, texts) => {
    const { mail } = texts;
    const details = [
        [mail.name, values.name],
        [mail.email, values.email],
        [mail.phone, values.phone],
        [mail.topic, texts.topics[values.topic]],
    ]
        .filter(([, value]) => value && value.trim())
        .map(([label, value]) => `${label} : ${value.trim()}`);
    return [mail.greeting, '', values.message.trim(), '', details.length ? `— ${mail.signature}` : '', ...details]
        .join('\n')
        .trim();
};

/**
 * Liens d'envoi depuis la boîte mail de l'utilisateur, pré-remplis : application installée
 * (mailto), Gmail et Outlook dans le navigateur, pour qui n'a pas de messagerie configurée.
 */
export const mailLinksOf = (to, values, texts) => {
    const subject = subjectOf(values, texts);
    const body = bodyOf(values, texts);
    const encode = encodeURIComponent;
    return {
        app: `mailto:${to}?subject=${encode(subject)}&body=${encode(body)}`,
        gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${encode(to)}&su=${encode(subject)}&body=${encode(body)}`,
        outlook: `https://outlook.live.com/mail/0/deeplink/compose?to=${encode(to)}&subject=${encode(subject)}&body=${encode(body)}`,
    };
};
